'use strict';

exports.__esModule = true;
exports['default'] = createAll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createProvider = require('./createProvider');

var _createProvider2 = _interopRequireDefault(_createProvider);

var _createInject = require('./createInject');

var _createInject2 = _interopRequireDefault(_createInject);

function createAll(React) {
  var Provider = _createProvider2['default'](React);
  var inject = _createInject2['default'](React);

  return { Provider: Provider, inject: inject };
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-tunnel/lib/components/createAll.js
// module id = 772
// module chunks = 4